// 出行
const goOut = resolve => require(['../view/benefit/goOut'], resolve)
const goOutwph = resolve => require(['../view/benefit/goOutwph'], resolve)
// 酒店
const Hotel = resolve => require(['../view/hotel/index'], resolve)
const HotelList = resolve => require(['../view/hotel/list'], resolve)
const HotelDetail = resolve => require(['../view/hotel/detail'], resolve)
const orderDetail = resolve => require(['../view/hotel/orderDetail'], resolve)
const advanceDetail = resolve => require(['../view/hotel/advanceDetail'], resolve)
const HotelorderList = resolve => require(['../view/hotel/orderList'], resolve)
// 机票
const airplane = resolve => require(['../view/airplane/index'], resolve)
const airList = resolve => require(['../view/airplane/list'], resolve)
const plane = resolve => require(['../view/airplane/plane'], resolve)
const advanceAir = resolve => require(['../view/airplane/advance'], resolve)
const add = resolve => require(['../view/airplane/add'], resolve)
const airOrder = resolve => require(['../view/airplane/myorder'], resolve)
const airOrderDetail = resolve => require(['../view/airplane/orderDetail'], resolve)
// 火车票
const train = resolve => require(['../view/train/index'], resolve)
const trainList = resolve => require(['../view/train/list'], resolve)
const seats = resolve => require(['../view/train/seats'], resolve)
const advancetrain = resolve => require(['../view/train/advance'], resolve)
// const add = resolve => require(['../view/airplane/add'], resolve)
const trainOrder = resolve => require(['../view/train/myorder'], resolve)
const trainOrderDetail = resolve => require(['../view/train/orderDetail'], resolve)
// 云店
const shopping = resolve => require(['../view/benefit/shopping'], resolve)
const nearshop = resolve => require(['../view/benefit/nearshop'], resolve)
const neardetail = resolve => require(['../view/benefit/neardetail'], resolve)
const shopDesc = resolve => require(['../view/benefit/shopDesc'], resolve)
const advance = resolve => require(['../view/benefit/advance'], resolve)
const clothing = resolve => require(['../view/benefit/clothing'], resolve)
const baoyou = resolve => require(['../view/home/baoyou'], resolve)
const cflist = resolve => require(['../view/benefit/cflist'], resolve)
// 拼团
const group = resolve => require(['../view/group/index'], resolve)
// 扶贫
const fupin = resolve => require(['../view/benefit/fupin'], resolve)
const fupinArea = resolve => require(['../view/benefit/fupinArea'], resolve)
// 店铺
const shop = resolve => require(['../view/benefit/shop'], resolve)
const goodDetail = resolve => require(['../view/benefit/goodDetail'], resolve)
const goodCar = resolve => require(['../view/goodCar/index'], resolve)
const comments = resolve => require(['../view/benefit/comments'], resolve)

// 订单
const confirm = resolve => require(['../view/myorder/confirm'], resolve)
const myorder = resolve => require(['../view/myorder/myorder'], resolve)
const khorder = resolve => require(['../view/myorder/khorder'], resolve)
const Return = resolve => require(['../view/myorder/return'], resolve)
const cancel = resolve => require(['../view/myorder/cancel'], resolve)
const returnDetail = resolve => require(['../view/myorder/returnDetail'], resolve)
const detail = resolve => require(['../view/myorder/detail'], resolve)
const ptdetail = resolve => require(['../view/myorder/ptdetail'], resolve)
const traveldetail = resolve => require(['../view/myorder/traveldetail'], resolve)
const comment = resolve => require(['../view/myorder/comment'], resolve)
const creditDetail = resolve => require(['../view/myorder/creditDetail'], resolve)
const wuliu = resolve => require(['../view/myorder/wuliu'], resolve)
// 拼团订单
const newptOrder = resolve => require(['../view/myorder/newptOrder'], resolve)
const groupOrder = resolve => require(['../view/myorder/groupOrder'], resolve)
const ptWithdraw = resolve => require(['../view/my/ptWithdraw'], resolve)
const ptWithdrawList = resolve => require(['../view/my/ptWithdrawList'], resolve)
const ptWithdrawApply = resolve => require(['../view/my/ptWithdrawApply'], resolve)

const routes = [
  {
    path: '/goOut',
    name: 'goOut',
    component: goOut,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/goOutwph',
    name: 'goOutwph',
    component: goOutwph,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/Hotel',
    name: 'Hotel',
    component: Hotel,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/HotelList',
    name: 'HotelList',
    component: HotelList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/HotelDetail',
    name: 'HotelDetail',
    component: HotelDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/Hotel/orderDetail',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/Hotel/advanceDetail',
    name: 'advanceDetail',
    component: advanceDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/HotelorderList',
    name: 'HotelorderList',
    component: HotelorderList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: shopping,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/clothing',
    name: 'clothing',
    component: clothing,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/nearshop',
    name: 'nearshop',
    component: nearshop,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/neardetail',
    name: 'neardetail',
    component: neardetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/shopDesc',
    name: 'shopDesc',
    component: shopDesc,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/group',
    name: 'group',
    component: group,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: shop,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/advance',
    name: 'advance',
    component: advance,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/cflist',
    name: 'cflist',
    component: cflist,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/goodDetail',
    name: 'goodDetail',
    component: goodDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/comments',
    name: 'comments',
    component: comments,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/goodCar',
    name: 'goodCar',
    component: goodCar,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/airplane',
    name: 'airplane',
    component: airplane,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/add',
    name: 'add',
    component: add,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/airList',
    name: 'airList',
    component: airList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/plane',
    name: 'plane',
    component: plane,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/advanceAir',
    name: 'advanceAir',
    component: advanceAir,
    meta: {
      keepalive: true
      // requireAuth: true
    }
  },
  {
    path: '/airOrder',
    name: 'airOrder',
    component: airOrder,
    meta: {
      keepalive: true
      // requireAuth: true
    }
  },
  {
    path: '/airOrderDetail',
    name: 'airOrderDetail',
    component: airOrderDetail,
    meta: {
      // keepalive: true
      // requireAuth: true
    }
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: confirm,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/myorder',
    name: 'myorder',
    component: myorder,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/khorder',
    name: 'khorder',
    component: khorder,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/newptOrder',
    name: 'newptOrder',
    component: newptOrder,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/groupOrder',
    name: 'groupOrder',
    component: groupOrder,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ptWithdrawList',
    name: 'ptWithdrawList',
    component: ptWithdrawList,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ptWithdrawApply',
    name: 'ptWithdrawApply',
    component: ptWithdrawApply,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ptWithdraw',
    name: 'ptWithdraw',
    component: ptWithdraw,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/myorder/detail',
    name: 'detail',
    component: detail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myorder/ptdetail',
    name: 'ptdetail',
    component: ptdetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myorder/traveldetail',
    name: 'traveldetail',
    component: traveldetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/creditDetail',
    name: 'creditDetail',
    component: creditDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myorder/cancel',
    name: 'cancel',
    component: cancel,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myorder/comment',
    name: 'comment',
    component: comment,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/Return',
    name: 'Return',
    component: Return,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/returnDetail',
    name: 'returnDetail',
    component: returnDetail,
    meta: {
      // requireAuth: true
    }
  },
  // 火车
  {
    path: '/train',
    name: 'train',
    component: train,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/trainList',
    name: 'trainList',
    component: trainList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/seats',
    name: 'seats',
    component: seats,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/advancetrain',
    name: 'advancetrain',
    component: advancetrain,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/trainOrder',
    name: 'trainOrder',
    component: trainOrder,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/trainOrderDetail',
    name: 'trainOrderDetail',
    component: trainOrderDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/baoyou',
    name: 'baoyou',
    component: baoyou,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/fupin',
    name: 'fupin',
    component: fupin,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/fupinArea',
    name: 'fupinArea',
    component: fupinArea,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/wuliu',
    name: 'wuliu',
    component: wuliu,
    meta: {
      // requireAuth: true
    }
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/benefit.js